import createAction from '@clearscore/helpers.create-action';

import { ROUTES_REINITIALISE } from './types';

/* eslint-disable import/prefer-default-export */
export const reinitialiseRoutes = (routes, accountIDVStatus, market) =>
    createAction(ROUTES_REINITIALISE, { routes, accountIDVStatus, market });
